export async function asyncTimeout(ms: number): Promise<void> {
  return new Promise( (resolve, reject) => {
    setTimeout( () => {
      resolve();
    } , ms);
  });
}
